import {css} from 'lit';
export const styles = css`:host {
  --radius: 50px;

  display: flex;
  height: var(--radius);
  color: var(--primary);
  font-size: 26px;
}

sl-progress-ring {
  --size: var(--radius);
  --track-color: var(--gray-300);
  --indicator-color: var(--primary);
  --track-width: 4px;
  --indicator-width: 4px;
}
`;
export default styles;
